module.exports = __webpack_public_path__ + "img/rectangle_2.bda08372.png";